import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type UserTableMessages = TableColumnsMessages &
  PopoverMessages & {
    // Column Messages
    nameColumn: string;
    emailColumn: string;
    phone1Column: string;
    phone2Column: string;
    statusColumn: string;
  };

export const USER_TABLE_MESSAGES: UserTableMessages = {
  //Columns messages
  nameColumn: "Nome",
  emailColumn: "Email",
  phone1Column: "Telefone",
  phone2Column: "Telefone Secundário",
  statusColumn: "Ativo",

  ...TABLE_COLUMNS_MESSAGES,
  ...POPOVER_MESSAGES,
};
